import { createPinia } from 'pinia'
import type { Pinia } from 'pinia'

export const pinia: Pinia = createPinia()
